import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { MODAL_TYPES } from './ModalTypes';
import { hideModal } from '../../../actions/modalActions';
import SharedActivityModal from './SharedActivityModal';

const GlobalActivityModal = () => {
  const dispatch = useDispatch();
  const { modalType, modalProps } = useSelector(state => state.modalReducer);

  switch (modalType) {
    case MODAL_TYPES.ACTIVITY:
      return (
        <SharedActivityModal
          show={true}
          closeModal={() => dispatch(hideModal())}
          reviewId={modalProps.reviewId}
          activeItem={modalProps.activeItem}
          enableCache={modalProps.enableCache}
        />
      );
    default:
      return null;
  }
};

export default GlobalActivityModal;
